import { render } from "./editRole.vue?vue&type=template&id=c89281b0&scoped=true"
import script from "./editRole.vue?vue&type=script&lang=js"
export * from "./editRole.vue?vue&type=script&lang=js"

import "./editRole.vue?vue&type=style&index=0&id=c89281b0&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89281b0"]])

export default __exports__